(ns io.daskul.tutorial.webapp.views.analytics
  "Analytics page — the strategic counterpart to Today, delegating to the
   framework dashboard component.

   Renders the :analytics group ONLY (#729): At a glance · Profit & Loss ·
   Collections · Growth · Programs, under one governing date selector. The old
   :snapshot Overview grab-bag is retired here — its useful signal moved into
   the themed sections — and :live (Action Items) stays on Today, which owns
   those queues; rendering them here would surface the same work twice."
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.widgets.dashboard.page :as dashboard.page]))

(defui analytics-page []
  ($ dashboard.page/dashboard-page
     {:title    "Analytics"
      :subtitle "How the center is doing"
      :groups   [:analytics]}))
